<div class="xi-modal__container account-password__container" *transloco="let t">
  <h2 class="xi-modal__title">{{ t('account-password-component.change-password') }}</h2>

  <form
    (ngSubmit)="confirm()"
    [formGroup]="passwordForm"
    class="xi-modal__content account-password__form"
  >
    <div class="account-password__form-container">
      @if (requireCurrentPassword) {
        <div class="account-password__input-wrapper">
          <xi-input-field
            appAutoFocus="xiInput"
            label="{{ t('account-password-component.current-password') }}"
            type="password"
            name="existingPassword"
            formControlName="existingPassword"
            [status]="accountPasswordStatuses.existingPw"
            (onChange)="onInputChange('existingPw')"
          >
          </xi-input-field>
        </div>
      }

      <div class="account-password__input-wrapper">
        <xi-input-field
          label="{{ t('account-password-component.new-password') }}"
          type="password"
          name="password"
          formControlName="password"
          [status]="accountPasswordStatuses.pw1"
          (onChange)="onInputChange('pw1')"
        ></xi-input-field>
      </div>

      <div class="account-password__input-wrapper">
        <xi-input-field
          label="{{ t('account-password-component.confirm-password') }}"
          type="password"
          name="passwordConfirm"
          formControlName="passwordConfirm"
          [status]="accountPasswordStatuses.pw2"
          (onChange)="onInputChange('pw2')"
        ></xi-input-field>
      </div>
    </div>
    <app-password-rules-check
      [password]="password.value"
      [(valid)]="allRulesValid"
    ></app-password-rules-check>
  </form>

  <div class="xi-modal__actions account-password__actions">
    <xi-default-button
      text="{{ t('account-password-component.cancel') }}"
      fill="text"
      type="button"
      (onClick)="close()"
    ></xi-default-button>

    <div>
      @if (isLoading) {
        <div class="xi-loader-container__inline-overlay">
          <xi-animation
            [height]="150"
            [width]="150"
            [loop]="true"
            animation="cx_loader"
          ></xi-animation>
        </div>
      }

      <xi-default-button
        text="{{ t('account-password-component.change-password') }}"
        [disabled]="!isFormValid || isLoading"
        (onClick)="confirm()"
      ></xi-default-button>
    </div>
  </div>
</div>
